// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__BVsup","visual":"style_visual__mzahN","layout":"style_layout__ttQ86","text":"style_text__Hrku0","card":"style_card__K+wV3","button":"style_button__tCMZs"};